/**
 * Public landing-lead endpoints (no auth). Used by the unrecognized-number flow:
 * pre-fill register from a lead the nurse created on rn.taskshealth.com, and
 * submit the "I already have an account, add this number" request.
 * getApiBase() already includes the `/api` prefix.
 */
import { getApiBase } from "./api-env";

export interface LeadPrefill {
    firstName: string | null;
    middleName: string | null;
    lastName: string | null;
    email: string | null;
    address: string | null;
    isRn: boolean;
}

/** Register pre-fill. Returns null unless the phone was verified recently. */
export async function getLeadByPhone(phone: string): Promise<LeadPrefill | null> {
    try {
        const res = await fetch(
            `${getApiBase()}/leads/by-phone?phone=${encodeURIComponent(phone)}`
        );
        if (!res.ok) {
            return null;
        }
        const data = (await res.json()) as { lead: LeadPrefill | null };
        return data.lead ?? null;
    } catch {
        return null;
    }
}

/** "I already have an account, add this number" — routed to back-office by email. */
export async function addNumberRequest(input: {
    existingPhone: string;
    newPhone: string;
    firstName: string;
    lastName?: string;
}): Promise<void> {
    const res = await fetch(`${getApiBase()}/leads/add-number-request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
    if (!res.ok) {
        throw new Error("Could not submit your request. Please try again.");
    }
}
